module.exports = __webpack_public_path__ + "static/ncsLogo-c87bb9fed5ef20b66ee686cd8c8e75d4.png";